<template>
  <div class="supplyfacecontainer">
    <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="实人认证"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>
    <div class="supplyface">
      <div class="title">请{{ name }}本人进行人脸验证</div>
      <img :src="$setPicSize(headimg)" alt="">
      <div class="guide-info">根据法律法规和监管要求，为保障平台交易安全，需要收集您的人脸信息用于实人认证，{{ isSJJ ? '奢竞界' : (isZLJ ? '找靓机' : '转转') }}将保护您的个人信息安全。</div>
      <div class="bottom">
        <z-checkbox-group v-model="radio">
          <z-checkbox v-if="isZZ" name="zz">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox v-if="isSJJ" name="sjj">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="sjjagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox name="privacy">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
          </z-checkbox>

          <z-checkbox v-if="isZLJ" name="zlj">
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
          </z-checkbox>
        </z-checkbox-group>
        <div class="buttonlist">
          <z-button @click="closePage">拒绝</z-button>
          <z-button type="primary" :disabled="!canSubmit" @click="startVerify">开始扫脸</z-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import native from '@zz-common/native-adapter'
import { compatibleHarmony, queryParams, isIOS, getCookie } from '@/lib/utils'
import { NavBar, Button, FixTop, Checkbox, CheckboxGroup } from '@zz-common/zz-ui';
import { lego } from '@zz-common/lego'
import { setPicSize } from '@zz-common/zz-utils'

const query = queryParams()

export default {
  name: 'FaceSupply',
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-checkbox-group': CheckboxGroup,
    'z-checkbox': Checkbox
  },
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'
    return {
      radio: [],
      name: decodeURI(query.name) || decodeURI(this.$route.query.name) || '',
      // 如果URL没有传sourcecode，根据不同APP设置默认值
      sourcecode: query.sourcecode || this.$route.query.sourcecode || (isSJJ ? 'c2p_selfmain_page' : 'card_selfmain_page'),
      strategyid: query.strategyid || this.$route.query.strategyid || '0', //策略ID
      headimg: require('./images/head.png'),
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      isSJJ // 奢竞界APP
    }
  },
  computed: {
    /**
     * 判断是否可以提交
     * 需要满足：所有显示的协议都已勾选
     */
    canSubmit() {
      // 个人信息处理授权书是必选的
      const hasPrivacy = this.radio.includes('privacy')
      // 转转实人认证服务协议（如果显示）
      const hasZZ = !this.isZZ || this.radio.includes('zz')
      // 找靓机身份识别服务协议（如果显示）
      const hasZLJ = !this.isZLJ || this.radio.includes('zlj')
      // 奢竞界实人认证服务协议（如果显示）
      const hasSJJ = !this.isSJJ || this.radio.includes('sjj')
      return hasPrivacy && hasZZ && hasZLJ && hasSJJ
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url)
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    sjjagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/691c3375ee471600647e64f8/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1',
        needClose: '0'
      })
    },
    closePage() {
      native.close()
    },
    startVerify() {
      lego.send({
        pagetype: 'auth_facesupply',
        actiontype: 'submit',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: native.in('zz') ? 'zz' : 'zlj'
        }
      })
      if (compatibleHarmony()) return;
      if (native.in('zz') || this.isSJJ) {
        native.wrap('startFaceVerify')(
          {
            sourceCode: this.sourcecode,
            isShowPrivacyPage: '0',
            strategyId: this.strategyid
          },
          (res) => {
            if (res.code == '0') {
              if (res.result == 1) {
                lego.send({
                  pagetype: 'auth_facesupply',
                  actiontype: 'success',
                  backup: {
                    sourcecode: this.sourcecode,
                    version: getCookie('v'),
                    app: native.in('zz') ? 'zz' : 'zlj'
                  }
                })
                this.$toast('认证成功').then(_res => {
                  native.close()
                })
              }

              if (res.result == 0) {
                lego.send({
                  pagetype: 'auth_facesupply',
                  actiontype: 'fail',
                  backup: {
                    sourcecode: this.sourcecode,
                    version: getCookie('v'),
                    app: native.in('zz') ? 'zz' : 'zlj'
                  }
                })
                this.$toast(res.errorMsg)
              }
            }
            if (res.code == '-1') {
              lego.send({
                pagetype: 'auth_facesupply',
                actiontype: 'fail',
                backup: {
                  sourcecode: this.sourcecode,
                  version: getCookie('v'),
                  app: native.in('zz') ? 'zz' : 'zlj'
                }
              })
              if (isIOS) {
                this.$toast(res.errorMsg)
              }
            }
          }
        )
      }

      if (native.in('zlj')) {
        native.wrap('faceRecognitionOcr')({
          source_code: this.sourcecode,
          card_name: '',
          card_no: ''
        },
        (res) => {
          this.res = JSON.stringify(res);
          const { statusCode, statusText, data: { agreementNo } = {} } = res;
          console.log('statusCode', statusCode);
          console.log('agreementNo', agreementNo);
          if (statusCode == '1' && agreementNo) {
            lego.send({
              pagetype: 'auth_facesupply',
              actiontype: 'success',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj'
              }
            })
            this.$toast('认证成功').then(_res => {
              native.close()
            })
          } else if (statusText) {
            lego.send({
              pagetype: 'auth_facesupply',
              actiontype: 'fail',
              backup: {
                sourcecode: this.sourcecode,
                version: getCookie('v'),
                app: native.in('zz') ? 'zz' : 'zlj'
              }
            })
            this.$toast(statusText)
          }
        }
        )
      }
    }
  },
  created() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
  },
  mounted() {
    lego.send({
      pagetype: 'auth_facesupply',
      actiontype: 'show',
      backup: {
        sourcecode: this.sourcecode,
        version: getCookie('v'),
        app: native.in('zz') ? 'zz' : 'zlj'
      }
    })
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>